import axios from 'axios'
import { fetchBaseQuery } from '@reduxjs/toolkit/query'
import queryString from 'query-string'

import { unAuthorized, setCsrfToken } from './actions/app'

const api = axios.create({
  baseURL: new URL('/api/', window.location.origin).href,
  withCredentials: true
})

export const configureApi = (dispatch, getState) => {
  api.interceptors.request.use((config) => {
    if (!config.url) {
      return config
    }

    const currentUrl = new URL(config.url, config.baseURL)
    // parse pathName to implement variables
    Object.entries(config.urlParams || {}).forEach(([k, v]) => {
      currentUrl.pathname = currentUrl.pathname.replace(`:${k}`, encodeURIComponent(v))
    })

    return {
      ...config,
      baseURL: `${currentUrl.protocol}//${currentUrl.host}`,
      url: currentUrl.pathname,
      headers: {
        ...config.headers,
        'x-xsrf-token': getState()?.app?.csrfToken || null
      }
    }
  })

  api.interceptors.response.use(
    (response) => {
      return response
    },
    (error) => {
      const isAuthenticated = JSON.parse(localStorage.getItem('auth'))
      if (error.response?.status === 401 && isAuthenticated) {
        dispatch(unAuthorized())
      }
      return Promise.reject(error)
    }
  )
}

const paramsSerializer = (params) => {
  return queryString.stringify(params, {
    arrayFormat: 'bracket',
    skipEmptyString: true,
    skipNull: true
  })
}

const baseQuery = fetchBaseQuery({
  baseUrl: '/api/',
  credentials: 'same-origin',
  paramsSerializer,
  prepareHeaders: (headers, { getState }) => {
    const token = getState().app.csrfToken || null
    if (token) {
      headers.set('x-xsrf-token', token)
    }
    return headers
  }
})

export const rtkBaseQuery = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions)

  const csrfToken = result.meta.response.headers.get('x-xsrf-token') || null

  if (csrfToken) {
    api.dispatch(setCsrfToken({ token: csrfToken }))
  }

  const isAuthenticated = JSON.parse(localStorage.getItem('auth')) === true

  if (result.error && result.error.status === 401 && isAuthenticated) {
    api.dispatch(unAuthorized())
  }

  return result
}

export default api
